import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";

export const LeadDataSlice = createSlice({
  name: "LeadDataSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    LeadDataRead: (state) => {
      state.isLoading = true;
    },
    successLeadData: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureLeadData: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearLeadData: (state) => {
      state.data = {};
    },
  },
});

export const {
  LeadDataRead,
  successLeadData,
  failureLeadData,
  clearLeadData,
} = LeadDataSlice.actions;

export default LeadDataSlice.reducer;
